module.exports = __webpack_public_path__ + "img/quickspin.99af1f82.svg";